/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { Header } from "@/components/Header";
import { useTranslation } from "react-i18next";
import { CssHome, CssKevlar, CssSuvinil, CssDexpro, CssEvino, CssEcom, CssEdp} from "./css";
import ReactHtmlParser from "html-react-parser";
import { Footer } from "@/components/Footer";

// CssHome
import setaAzul from "@/assets/cases/conteudoSocial/setaAzul.png";

//KEVLAR
import bgKevlar from "@/assets/cases/conteudoSocial/bgKevlar.jpg";
import zAzul from "@/assets/cases/conteudoSocial/zAzul.png";
import kevlarLogo from "@/assets/cases/conteudoSocial/kevlar.png";
import fotoKevlar from "@/assets/cases/conteudoSocial/fotoKevlar.jpg";
import quadroKevlar from "@/assets/cases/conteudoSocial/quadroKevlar.png";
import zBranco from "@/assets/cases/conteudoSocial/zBranco.png";
import faixaAzul from "@/assets/cases/conteudoSocial/faixaAzul.png";

//SUVINIL
import suvinilLogo from "@/assets/cases/conteudoSocial/suvinil-logo.png";
import gifSuvinil from "@/assets/cases/conteudoSocial/bannerSuvinil.jpg";

import cardInstaSuvinil1 from "@/assets/cases/conteudoSocial/card-insta-suvinil1.jpg";
import cardInstaSuvinil2 from "@/assets/cases/conteudoSocial/card-insta-suvinil2.jpg";
import cardInstaSuvinil3 from "@/assets/cases/conteudoSocial/card-insta-suvinil3.jpg";
import cardInstaSuvinil4 from "@/assets/cases/conteudoSocial/card-insta-suvinil4.jpg";

import celularSuvinil from "@/assets/cases/conteudoSocial/celular-suvinil.png";

import postSuvinil1 from "@/assets/cases/conteudoSocial/post-suvinil1.png";
import postSuvinil2 from "@/assets/cases/conteudoSocial/post-suvinil2.png";
import postSuvinil3 from "@/assets/cases/conteudoSocial/post-suvinil3.png";
import postSuvinil4 from "@/assets/cases/conteudoSocial/post-suvinil4.png";
import postSuvinil5 from "@/assets/cases/conteudoSocial/post-suvinil5.png";
import postSuvinil6 from "@/assets/cases/conteudoSocial/post-suvinil6.png";
import postSuvinil7 from "@/assets/cases/conteudoSocial/post-suvinil7.png";
import postSuvinil8 from "@/assets/cases/conteudoSocial/post-suvinil8.png";
import postSuvinil9 from "@/assets/cases/conteudoSocial/post-suvinil9.png";
import postSuvinil10 from "@/assets/cases/conteudoSocial/post-suvinil10.png";

import noteSuvinil from "@/assets/cases/conteudoSocial/note-suvinil.png";
import riscoSuvinil from "@/assets/cases/conteudoSocial/risco-suvinil.png";
import faixaSuvinil from "@/assets/cases/conteudoSocial/faixa-suvinil.png";

//DEXPRO
import logoDexpro from "@/assets/cases/conteudoSocial/logo_dexpro.png";
import gifDexpro from "@/assets/cases/conteudoSocial/bannerDexco.jpg";

import cardDexpro1 from "@/assets/cases/conteudoSocial/card_dexpro1.png";
import cardDexpro2 from "@/assets/cases/conteudoSocial/card_dexpro2.png";
import cardDexpro3 from "@/assets/cases/conteudoSocial/card_dexpro3.png";
import cardDexpro4 from "@/assets/cases/conteudoSocial/card_dexpro4.png";
import cardDexpro5 from "@/assets/cases/conteudoSocial/card_dexpro5.png";

import celularDexpro from "@/assets/cases/conteudoSocial/celular_dexpro.png";

import instaDexpro1 from "@/assets/cases/conteudoSocial/insta_dexpro1.png";
import instaDexpro2 from "@/assets/cases/conteudoSocial/insta_dexpro2.png";
import instaDexpro3 from "@/assets/cases/conteudoSocial/insta_dexpro3.png";
import instaDexpro4 from "@/assets/cases/conteudoSocial/insta_dexpro4.png";
import instaDexpro5 from "@/assets/cases/conteudoSocial/insta_dexpro5.png";

import noteDexpro from "@/assets/cases/conteudoSocial/note_dexpro.png";
import vetorDexpro from "@/assets/cases/conteudoSocial/vetor_dexpro.png";

//EVINO
import logoEvino from "@/assets/cases/conteudoSocial/logo-evino.png";
import vinhoEvino1 from "@/assets/cases/conteudoSocial/vinho1.jpg";
import vinhoEvino2 from "@/assets/cases/conteudoSocial/vinho2.jpg";
import vinhoEvino3 from "@/assets/cases/conteudoSocial/vinho3.jpg";

//ECOM
import logoEcom from "@/assets/cases/conteudoSocial/logo-ecom.png";
import gifEcom from "@/assets/cases/conteudoSocial/bannerEcom.jpg";

import cardEcom1 from "@/assets/cases/conteudoSocial/card1-ecom.jpg";
import cardEcom2 from "@/assets/cases/conteudoSocial/card2-ecom.jpg";
import cardEcom3 from "@/assets/cases/conteudoSocial/card3-ecom.jpg";
import cardEcom4 from "@/assets/cases/conteudoSocial/card4-ecom.jpg";

import celularEcom from "@/assets/cases/conteudoSocial/celular-ecom.png";

import noteEcom from "@/assets/cases/conteudoSocial/note-ecom.png";
import riscoEcom from "@/assets/cases/conteudoSocial/risco-ecom.png";
import riscoVazadoEcom from "@/assets/cases/conteudoSocial/risco-vazado-ecom.png";

//EDP
import logoEdp from "@/assets/cases/conteudoSocial/logo-edp.png";
import cardEdp1 from "@/assets/cases/conteudoSocial/card1-edp.png";
import cardEdp2 from "@/assets/cases/conteudoSocial/card2-edp.png";
import cardEdp3 from "@/assets/cases/conteudoSocial/card3-edp.png";
import cardEdp4 from "@/assets/cases/conteudoSocial/card4-edp.png";
import celularEdp from "@/assets/cases/conteudoSocial/celular-edp.png";

const clientLinks = [
	{ key: "kevlar", href: "#kevlar" },
	{ key: "pintouParceriaSuvinil", href: "#Suvinil" },
	{ key: "clubeDexpro", href: "#Dexpro" },
	{ key: "evino", href: "#Evino" },
	{ key: "ecomEnergia", href: "#Ecom" },
	{ key: "edp", href: "#Edp" }
];

const CasesConteudoSocial = () => {
	const { t } = useTranslation();

	const sectionKevlarRef = useRef(null);
	const [kevlarVisible, setKevlarVisible] = useState(false);

	const sectionKevlarExtraRef = useRef(null);
	const [kevlarExtraVisible, setKevlarExtraVisible] = useState(false);	
	
	useEffect(() => {
		const section = sectionKevlarRef.current;

		if (!section) return;

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setKevlarVisible(true);
					observer.unobserve(entry.target);
				}
			},
			{
				threshold: 0.08,
				rootMargin: "0px 0px -10% 0px",
			}
		);

		observer.observe(section);

		return () => {
			observer.disconnect();
		};
	}, []);

	useEffect(() => {
		const section = sectionKevlarExtraRef.current;

		if (!section) return;

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setKevlarExtraVisible(true);
					observer.unobserve(entry.target);
				}
			},
			{
				threshold: 0.10,
				rootMargin: "0px 0px -10% 0px",
			}
		);

		observer.observe(section);

		return () => {
			observer.disconnect();
		};
	}, []);

	const sectionSuvinilIntroRef = useRef(null);
	const [suvinilIntroVisible, setSuvinilIntroVisible] = useState(false);

	const sectionSuvinilInstaRef = useRef(null);
	const [suvinilInstaVisible, setSuvinilInstaVisible] = useState(false);

	const sectionSuvinilYoutubeRef = useRef(null);
	const [suvinilYoutubeVisible, setSuvinilYoutubeVisible] = useState(false);

	const sectionSuvinilPostsRef = useRef(null);
	const [suvinilPostsVisible, setSuvinilPostsVisible] = useState(false);


	const suvinilInstaCards = [
		cardInstaSuvinil1,
		cardInstaSuvinil2,
		cardInstaSuvinil3,
		cardInstaSuvinil4,
	];
	
	const suvinilPostsLeft = [
		postSuvinil1,
		postSuvinil2,
		postSuvinil3,
		postSuvinil4,
		postSuvinil5,
	];

	const suvinilPostsRight = [
		postSuvinil6,
		postSuvinil7,
		postSuvinil8,
		postSuvinil9,
		postSuvinil10,
	];

	useEffect(() => {
		const sections = [
				{
					ref: sectionSuvinilIntroRef,
					setVisible: setSuvinilIntroVisible,
					threshold: 0.12,
				},
				{
					ref: sectionSuvinilInstaRef,
					setVisible: setSuvinilInstaVisible,
					threshold: 0.12,
				},				
				{
					ref: sectionSuvinilYoutubeRef,
					setVisible: setSuvinilYoutubeVisible,
					threshold: 0.12,
				},
				{
					ref: sectionSuvinilPostsRef,
					setVisible: setSuvinilPostsVisible,
					threshold: 0.10,
				}
		];

		const observers = sections.map(({ ref, setVisible, threshold }) => {
		const section = ref.current;

		if (!section) return null;

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setVisible(true);
					observer.unobserve(entry.target);
				}
			},
			{
				threshold,
				rootMargin: "0px 0px -10% 0px",
			}
		);

		observer.observe(section);

		return observer;
		});

		return () => {
			observers.forEach((observer) => {
				if (observer) observer.disconnect();
			});
		};
	}, []);


	//dexco
	const sectionDexproIntroRef = useRef(null);
	const [dexproIntroVisible, setDexproIntroVisible] = useState(false);

	const sectionDexproInstaRef = useRef(null);
	const [dexproInstaVisible, setDexproInstaVisible] = useState(false);

	const sectionDexproPostsRef = useRef(null);
	const [dexproPostsVisible, setDexproPostsVisible] = useState(false);

	const sectionDexproYoutubeRef = useRef(null);
	const [dexproYoutubeVisible, setDexproYoutubeVisible] = useState(false);

	const dexproInstaCards = [
		cardDexpro1,
		cardDexpro2,
		cardDexpro3,
		cardDexpro4,
		cardDexpro5,
	];

	const dexproPosts = [
		instaDexpro1,
		instaDexpro2,
		instaDexpro3,
		instaDexpro4,
		instaDexpro5,
	];

	useEffect(() => {
		const sections = [
			{
				ref: sectionDexproIntroRef,
				setVisible: setDexproIntroVisible,
				threshold: 0.12,
			},
			{
				ref: sectionDexproInstaRef,
				setVisible: setDexproInstaVisible,
				threshold: 0.12,
			},
			{
				ref: sectionDexproPostsRef,
				setVisible: setDexproPostsVisible,
				threshold: 0.10,
			},
			{
				ref: sectionDexproYoutubeRef,
				setVisible: setDexproYoutubeVisible,
				threshold: 0.12,
			},
		];

		const observers = sections.map(({ ref, setVisible, threshold }) => {
			const section = ref.current;

			if (!section) return null;

			const observer = new IntersectionObserver(
				([entry]) => {
					if (entry.isIntersecting) {
						setVisible(true);
						observer.unobserve(entry.target);
					}
				},
				{
					threshold,
					rootMargin: "0px 0px -10% 0px",
				}
			);

			observer.observe(section);

			return observer;
		});

		return () => {
			observers.forEach((observer) => {
				if (observer) observer.disconnect();
			});
		};
	}, []);

	//evino
	const sectionEvinoIntroRef = useRef(null);
	const [evinoIntroVisible, setEvinoIntroVisible] = useState(false);

	const sectionEvinoVinhosRef = useRef(null);
	const [evinoVinhosVisible, setEvinoVinhosVisible] = useState(false);

	const evinoVinhos = [
		vinhoEvino1,
		vinhoEvino2,
		vinhoEvino3,
	];

	useEffect(() => {
		const sections = [
			{
				ref: sectionEvinoIntroRef,
				setVisible: setEvinoIntroVisible,
				threshold: 0.12,
			},
			{
				ref: sectionEvinoVinhosRef,
				setVisible: setEvinoVinhosVisible,
				threshold: 0.12,
			},
		];

		const observers = sections.map(({ ref, setVisible, threshold }) => {
			const section = ref.current;

			if (!section) return null;

			const observer = new IntersectionObserver(
				([entry]) => {
					if (entry.isIntersecting) {
						setVisible(true);
						observer.unobserve(entry.target);
					}
				},
				{
					threshold,
					rootMargin: "0px 0px -10% 0px",
				}
			);

			observer.observe(section);

			return observer;
		});

		return () => {
			observers.forEach((observer) => {
				if (observer) observer.disconnect();
			});
		};
	}, []);

	//ECOM
	const sectionEcomIntroRef = useRef(null);
	const [ecomIntroVisible, setEcomIntroVisible] = useState(false);

	const sectionEcomInstaRef = useRef(null);
	const [ecomInstaVisible, setEcomInstaVisible] = useState(false);

	const sectionEcomYoutubeRef = useRef(null);
	const [ecomYoutubeVisible, setEcomYoutubeVisible] = useState(false);

	const ecomInstaCards = [
		cardEcom1,
		cardEcom2,
		cardEcom3,
		cardEcom4,
	];

	useEffect(() => {
		const sections = [
			{
				ref: sectionEcomIntroRef,
				setVisible: setEcomIntroVisible,
				threshold: 0.12,
			},
			{
				ref: sectionEcomInstaRef,
				setVisible: setEcomInstaVisible,
				threshold: 0.12,
			},
			{
				ref: sectionEcomYoutubeRef,
				setVisible: setEcomYoutubeVisible,
				threshold: 0.12,
			},
		];

		const observers = sections.map(({ ref, setVisible, threshold }) => {
			const section = ref.current;

			if (!section) return null;

			const observer = new IntersectionObserver(
				([entry]) => {
					if (entry.isIntersecting) {
						setVisible(true);
						observer.unobserve(entry.target);
					}
				},
				{
					threshold,
					rootMargin: "0px 0px -10% 0px",
				}
			);

			observer.observe(section);

			return observer;
		});

		return () => {
			observers.forEach((observer) => {
				if (observer) observer.disconnect();
			});
		};
	}, []);

		//EDP
	const sectionEdpIntroRef = useRef(null);
	const [edpIntroVisible, setEdpIntroVisible] = useState(false);

	const sectionEdpLinkedinRef = useRef(null);
	const [edpLinkedinVisible, setEdpLinkedinVisible] = useState(false);

	const edpCards = [
		cardEdp1,
		cardEdp2,
		cardEdp3,
		cardEdp4,
	];

	useEffect(() => {
		const sections = [
			{
				ref: sectionEdpIntroRef,
				setVisible: setEdpIntroVisible,
				threshold: 0.12,
			},
			{
				ref: sectionEdpLinkedinRef,
				setVisible: setEdpLinkedinVisible,
				threshold: 0.12,
			},
		];

		const observers = sections.map(({ ref, setVisible, threshold }) => {
			const section = ref.current;

			if (!section) return null;

			const observer = new IntersectionObserver(
				([entry]) => {
					if (entry.isIntersecting) {
						setVisible(true);
						observer.unobserve(entry.target);
					}
				},
				{
					threshold,
					rootMargin: "0px 0px -10% 0px",
				}
			);

			observer.observe(section);

			return observer;
		});

		return () => {
			observers.forEach((observer) => {
				if (observer) observer.disconnect();
			});
		};
	}, []);

	return (
		<>
			<Helmet>
				<title>Zest Ag | Cases | Conteúdo Social</title>

				<link rel="shortcut icon" href="https://zest.ag/favicon.png?v=3" />
				<link rel="icon" type="image/png" href="https://zest.ag/favicon.png?v=3" />
				<link rel="apple-touch-icon" href="https://zest.ag/favicon.png?v=3" />

				<meta name="description" content="Zest AG - The full responsa agency" />
				<meta
					name="keywords"
					content="Zest One, Agência de marketing, negócios e interesses do cliente, inbound"
				/>

				<meta property="og:url" content="https://zest.ag/CasesConteudoSocial" />
				<meta property="og:type" content="website" />
				<meta property="og:title" content="Zest Ag | Cases | Conteúdo Social" />
				<meta property="og:description" content="Zest Ag - The full responsa agency" />
				<meta property="og:image" content="https://zest.ag/avatar.jpg" />
			</Helmet>

			<Header />
			<div className="clear" />

			<CssHome>
				<section className="caseHero">
					<div className="caseContainer">					

						<div className="heroContent">
							<div className="heroLeft">
								<h1 className="heroTitle">
									<span className="titleLine titleTop">
										{t("casesConteudoSocial.tituloLinha1")}
									</span>

									<span className="titleLine titleBottom">
										{ReactHtmlParser(t("casesConteudoSocial.tituloLinha2"))}
									</span>
								</h1>

								<div className="heroClients">
									<h2>{t("casesConteudoSocial.cliqueConfira")}</h2>

									<div className="clientsGrid">
										{clientLinks.map((item) => (
											<a key={item.key} href={item.href} className="clientLink">
												<img src={setaAzul} alt="" />
												<span>{t(`casesConteudoSocial.clientes.${item.key}`)}</span>
											</a>
										))}
									</div>
								</div>
							</div>

							<div className="heroRight">
								<p className="heroDescription">
									{ReactHtmlParser(t("casesConteudoSocial.descricao"))}
								</p>
							</div>
						</div>
					</div>
				</section>
			</CssHome>

			<CssKevlar
				ref={sectionKevlarRef}
				className={`${kevlarVisible ? "isVisible" : ""} ${kevlarExtraVisible ? "isExtraVisible" : ""}`}
				id="kevlar"
			>
				<section className="kevlarSocialSection">
					<div className="kevlarSocialContainer">

						<img
							src={zAzul}
							alt=""
							className="kevlarSocialZ"
						/>

						<div className="kevlarSocialLogoBox">
							<img
								src={kevlarLogo}
								alt="Kevlar na Stock Car"
								className="kevlarSocialLogo"
							/>

							<p className="kevlarSocialUser">
								{t("casesConteudoSocial.kevlarInstagram")}
							</p>
						</div>

						<p className="kevlarSocialText">
							{ReactHtmlParser(t("casesConteudoSocial.kevlarDescricao"))}
						</p>

					</div>
				</section>

				<section
					ref={sectionKevlarExtraRef}
					className="kevlarExtraSection"
					
				>
					{/* PARTE 1: bg, 100k, foto, 53k e zBranco */}
					<div 
						className="kevlarExtraPartOne"
						style={{ backgroundImage: `url(${bgKevlar})` }}
					>					

						<div className="kevlarExtraContainer">

							<div className="kevlarMetric kevlarMetric100">
								<strong>+30%</strong>
								<span>
									{ReactHtmlParser(t("casesConteudoSocial.kevlarIndicador100"))}
								</span>
							</div>

							<div className="kevlarPhotoMainWrap">
								<img
									src={fotoKevlar}
									alt=""
									className="kevlarPhotoMain"
								/>
							</div>

							<div className="kevlarMetric kevlarMetric53">
								<strong>+10.000</strong>
								<span>
									{ReactHtmlParser(t("casesConteudoSocial.kevlarIndicador53"))}
								</span>
							</div>

							<img
								src={zBranco}
								alt=""
								className="kevlarWhiteZ"
							/>

						</div>
					</div>

					{/* PARTE 2: quadroKevlar e faixaAzul */}
					<div className="kevlarExtraPartTwo">
						<div className="kevlarFrameContainer">

							<div className="kevlarGridWrap">
								<img
									src={quadroKevlar}
									alt=""
									className="kevlarGridImage"
								/>
							</div>

							<img
								src={faixaAzul}
								alt=""
								className="kevlarBlueStripe"
							/>

						</div>
					</div>
				</section>
			</CssKevlar>

			<CssSuvinil id="Suvinil">
				<section
					ref={sectionSuvinilIntroRef}
					className={`suvinilIntroSection ${suvinilIntroVisible ? "isVisible" : ""}`}
					id="pintouParceriaSuvinil"
				>
					<div className="suvinilIntroContainer">

						<div className="suvinilIntroTop">
							<div className="suvinilIntroBrand">
								<img
									src={suvinilLogo}
									alt="Pintou Parceria Suvinil"
									className="suvinilLogo"
								/>

								<p className="suvinilUser">
									{t("casesConteudoSocial.suvinilInstagram")}
								</p>
							</div>

							<p className="suvinilIntroText">
								{ReactHtmlParser(t("casesConteudoSocial.suvinilDescricao"))}
							</p>
						</div>

						<div className="suvinilGifWrap">
							<img
								src={gifSuvinil}
								alt=""
								className="suvinilGif"
							/>
						</div>

					</div>
				</section>
			
				<div className="clear"/>

				<section
					ref={sectionSuvinilInstaRef}
					className={`suvinilInstaSection ${suvinilInstaVisible ? "isVisible" : ""}`}
				>
					<div className="suvinilInstaContainer">

						<div className="suvinilInstaHeader">
							<h2>Instagram</h2>

							<p>
								{ReactHtmlParser(t("casesConteudoSocial.suvinilInstagramTexto"))}
							</p>
						</div>

						<div className="suvinilInstaCards">
							{suvinilInstaCards.map((card, index) => (
								<div
									key={index}
									className={`suvinilInstaCard suvinilInstaCard${index + 1}`}
								>
									<img src={card} alt="" />
								</div>
							))}
						</div>

						<div className="suvinilPhoneArea">
							<div className="suvinilMetric suvinilMetric3m">
								<strong>+15</strong>
								<span>{ReactHtmlParser(t("casesConteudoSocial.suvinil15"))}</span>
							</div>

							<img
								src={celularSuvinil}
								alt=""
								className="suvinilPhone"
							/>

							<div className="suvinilMetric suvinilMetric155k">
								<strong>150K</strong>
								<span>{ReactHtmlParser(t("casesConteudoSocial.suvinil150"))}</span>
							</div>
						</div>

					</div>
				</section>

				<section
					ref={sectionSuvinilPostsRef}
					className={`suvinilPostsSection ${suvinilPostsVisible ? "isVisible" : ""}`}
				>
					<div className="suvinilPostsContainer">

						<p className="suvinilPostsText">
							{ReactHtmlParser(t("casesConteudoSocial.suvinilPostsTexto"))}
						</p>

						<div className="suvinilPostsRow suvinilPostsRowLeft">
							{suvinilPostsLeft.map((post, index) => (
								<div
									key={index}
									className={`suvinilPost suvinilPost${index + 1}`}
								>
									<img src={post} alt="" />
								</div>
							))}
						</div>

						<div className="suvinilPostsRow suvinilPostsRowRight">
							{suvinilPostsRight.map((post, index) => (
								<div
									key={index}
									className={`suvinilPost suvinilPost${index + 6}`}
								>
									<img src={post} alt="" />
								</div>
							))}
						</div>

					</div>
				</section>

				<section
					ref={sectionSuvinilYoutubeRef}
					className={`suvinilYoutubeSection ${suvinilYoutubeVisible ? "isVisible" : ""}`}
				>
					<div className="suvinilYoutubeContainer">

						<div className="suvinilYoutubeHeader">
							<h2>Youtube</h2>

							<p>
								{ReactHtmlParser(t("casesConteudoSocial.suvinilYoutubeTexto"))}
							</p>
						</div>

						<img
							src={riscoSuvinil}
							alt=""
							className="suvinilRisco"
						/>

						<img
							src={faixaSuvinil}
							alt=""
							className="suvinilFaixa"
						/>

						<div className="suvinilYoutubeMetric suvinilYoutubeMetric5m">
							<strong>+5M</strong>
							<span>views</span>
						</div>

						<img
							src={noteSuvinil}
							alt=""
							className="suvinilNote"
						/>

						<div className="suvinilYoutubeMetric suvinilYoutubeMetric34k">
							<strong>+34K</strong>
							<span>inscritos</span>
						</div>

					</div>
				</section>
			</CssSuvinil>

			<CssDexpro id="Dexpro">
				{/* =========================================================
					PARTE 1 - INTRO DEXPRO
				========================================================= */}
				<section
					ref={sectionDexproIntroRef}
					className={`dexproIntroSection ${dexproIntroVisible ? "isVisible" : ""}`}
				>
					<div className="dexproIntroTop">
						<div className="dexproIntroBrand">
							<img
								src={logoDexpro}
								alt="Clube Dexpro"
								className="dexproLogo"
							/>

							<p className="dexproUser">
								{t("casesConteudoSocial.dexproInstagram")}
							</p>
						</div>

						<p className="dexproIntroText">
							{ReactHtmlParser(t("casesConteudoSocial.dexproDescricao"))}
						</p>
					</div>

					<div className="dexproGifWrap">
						<img
							src={gifDexpro}
							alt=""
							className="dexproGif"
						/>
					</div>
				</section>

				{/* =========================================================
					PARTE 2 - INSTAGRAM
				========================================================= */}
				<section
					ref={sectionDexproInstaRef}
					className={`dexproInstaSection ${dexproInstaVisible ? "isVisible" : ""}`}
				>
					<div className="dexproInstaContainer">
						<div className="dexproInstaHeader">
							<h2>Instagram</h2>

							<p>
								{ReactHtmlParser(t("casesConteudoSocial.dexproInstagramTexto"))}
							</p>
						</div>

						<div className="dexproCardsRow">
							{dexproInstaCards.map((card, index) => (
								<div
									key={index}
									className={`dexproCard dexproCard${index + 1}`}
								>
									<img src={card} alt="" />
								</div>
							))}
						</div>

						<div className="dexproInstaBottom">
							<div className="dexproMetric dexproMetric33k">
								<strong>+ 1000 %</strong>
								<span>{t("casesConteudoSocial.dexproSeguidores")}</span>
							</div>

							{/* <div className="dexproMetric dexproMetric60k">
								<strong>60K</strong>
								<span>{t("casesConteudoSocial.dexproEngajamento")}</span>
							</div>
 							*/}
							<img
								src={celularDexpro}
								alt=""
								className="dexproPhone"
							/>
						</div>
					</div>
				</section>

				{/* =========================================================
					PARTE 3 - POSTS
				========================================================= */}
				<section
					ref={sectionDexproPostsRef}
					className={`dexproPostsSection ${dexproPostsVisible ? "isVisible" : ""}`}
				>
					<div className="dexproPostsContainer">
						<p className="dexproPostsText">
							{ReactHtmlParser(t("casesConteudoSocial.dexproPostsTexto"))}
						</p>

						<div className="dexproPostsRow">
							{dexproPosts.map((post, index) => (
								<div
									key={index}
									className={`dexproPost dexproPost${index + 1}`}
								>
									<img src={post} alt="" />
								</div>
							))}
						</div>
					</div>
				</section>

				{/* =========================================================
					PARTE 4 - YOUTUBE
				========================================================= */}
				<section
					ref={sectionDexproYoutubeRef}
					className={`dexproYoutubeSection ${dexproYoutubeVisible ? "isVisible" : ""}`}
				>
					<div className="dexproYoutubeContainer">
						<div className="dexproYoutubeHeader">
							<h2>Youtube</h2>
{/* 
							<p>
								{ReactHtmlParser(t("casesConteudoSocial.dexproYoutubeTexto"))}
							</p> */}
						</div>

						<div className="dexproYoutubeStage">
							<img
								src={vetorDexpro}
								alt=""
								className="dexproYoutubeVector"
							/>

							<div className="dexproYoutubeMetric dexproYoutubeMetric13k">
								<strong>+13K</strong>
								<span>{t("casesConteudoSocial.dexproViews")}</span>
							</div>

							<img
								src={noteDexpro}
								alt=""
								className="dexproNote"
							/>

							<div className="dexproYoutubeMetric dexproYoutubeMetric700">
								<strong>+700</strong>
								<span>{t("casesConteudoSocial.dexproInscritos")}</span>
							</div>
						</div>
					</div>
				</section>
			</CssDexpro>

			<CssEvino id="Evino">
					{/* =========================================================
						PARTE 1 - INTRO EVINO
					========================================================= */}
					<section
						ref={sectionEvinoIntroRef}
						className={`evinoIntroSection ${evinoIntroVisible ? "isVisible" : ""}`}
					>
						<div className="evinoIntroTop">
							<div className="evinoIntroBrand">
								<img
									src={logoEvino}
									alt="Evino"
									className="evinoLogo"
								/>

								<p className="evinoUser">
									{t("casesConteudoSocial.evinoInstagram")}
								</p>
							</div>

							<p className="evinoIntroText">
								{ReactHtmlParser(t("casesConteudoSocial.evinoDescricao"))}
							</p>
						</div>
					</section>

					{/* =========================================================
						PARTE 2 - VINHOS
					========================================================= */}
					<section
						ref={sectionEvinoVinhosRef}
						className={`evinoVinhosSection ${evinoVinhosVisible ? "isVisible" : ""}`}
					>
						<div className="evinoVinhosContainer">
							{evinoVinhos.map((vinho, index) => (
								<div
									key={index}
									className={`evinoVinhoCard evinoVinhoCard${index + 1}`}
								>
									<img src={vinho} alt="" />
								</div>
							))}
						</div>
					</section>
			</CssEvino>

			<CssEcom id="Ecom">
				{/* =========================================================
					PARTE 1 - INTRO ECOM
				========================================================= */}
				<section
					ref={sectionEcomIntroRef}
					className={`ecomIntroSection ${ecomIntroVisible ? "isVisible" : ""}`}
				>
					<div className="ecomIntroTop">
						<div className="ecomIntroBrand">
							<img
								src={logoEcom}
								alt="Ecom Energia"
								className="ecomLogo"
							/>

							<p className="ecomUser">
								{t("casesConteudoSocial.ecomInstagram")}
							</p>
						</div>

						<p className="ecomIntroText">
							{ReactHtmlParser(t("casesConteudoSocial.ecomDescricao"))}
						</p>
					</div>

					<div className="ecomGifWrap">
						<img
							src={gifEcom}
							alt=""
							className="ecomGif"
						/>
					</div>
				</section>

				{/* =========================================================
					PARTE 2 - INSTAGRAM
				========================================================= */}
				<section
					ref={sectionEcomInstaRef}
					className={`ecomInstaSection ${ecomInstaVisible ? "isVisible" : ""}`}
				>
					<div className="ecomInstaContainer">
						<div className="ecomInstaHeader">
							<h2>Instagram</h2>

							<p>
								{ReactHtmlParser(t("casesConteudoSocial.ecomInstagramTexto"))}
							</p>
						</div>

						<div className="ecomInstaStage">
							<div className="ecomCardsGrid">
								{ecomInstaCards.map((card, index) => (
									<div
										key={index}
										className={`ecomCard ecomCard${index + 1}`}
									>
										<img src={card} alt="" />
									</div>
								))}
							</div>

							<img
								src={celularEcom}
								alt=""
								className="ecomPhone"
							/>

							<div className="ecomMetric ecomMetric10k">
								<strong>+10K</strong>
								<span>{t("casesConteudoSocial.ecomSeguidores")}</span>
							</div>

							<div className="ecomMetric ecomMetric8k">
								<strong>+8K</strong>
								<span>{t("casesConteudoSocial.ecomEngajamento")}</span>
							</div>
						</div>
					</div>
				</section>

				{/* =========================================================
					PARTE 4 - YOUTUBE
				========================================================= */}
				<section
					ref={sectionEcomYoutubeRef}
					className={`ecomYoutubeSection ${ecomYoutubeVisible ? "isVisible" : ""}`}
				>
					<div className="ecomYoutubeContainer">
						<div className="ecomYoutubeHeader">
							<h2>Youtube</h2>

							<p>
								{ReactHtmlParser(t("casesConteudoSocial.ecomYoutubeTexto"))}
							</p>
						</div>

						<div className="ecomYoutubeStage">
							<img
								src={riscoVazadoEcom}
								alt=""
								className="ecomRiscoVazado"
							/>

							<img
								src={riscoEcom}
								alt=""
								className="ecomRisco"
							/>

							<div className="ecomYoutubeMetric ecomYoutubeMetric150k">
								<strong>+150K</strong>
								<span>{t("casesConteudoSocial.ecomViews")}</span>
							</div>

							<img
								src={noteEcom}
								alt=""
								className="ecomNote"
							/>

							<div className="ecomYoutubeMetric ecomYoutubeMetric2mil">
								<strong>+2<span>mil</span></strong>
								<small>{t("casesConteudoSocial.ecomInscritos")}</small>
							</div>
						</div>
					</div>
				</section>
			</CssEcom>

			<CssEdp id="Edp">
				{/* =========================================================
					PARTE 1 - INTRO EDP
				========================================================= */}
				<section
					ref={sectionEdpIntroRef}
					className={`edpIntroSection ${edpIntroVisible ? "isVisible" : ""}`}
				>
					<div className="edpIntroContainer">
						<img
							src={logoEdp}
							alt="EDP"
							className="edpLogo"
						/>

						<div className="edpIntroInfo">
							<h2>{t("casesConteudoSocial.edpCanal")}</h2>

							<h3>{t("casesConteudoSocial.edpConta")}</h3>
						</div>

						<p className="edpIntroText">
							{ReactHtmlParser(t("casesConteudoSocial.edpDescricao"))}
						</p>
					</div>
				</section>

				{/* =========================================================
					PARTE 2 - LINKEDIN
				========================================================= */}
				<section
					ref={sectionEdpLinkedinRef}
					className={`edpLinkedinSection ${edpLinkedinVisible ? "isVisible" : ""}`}
				>
					<div className="edpLinkedinContainer">
						<div className="edpMetrics">
							<div className="edpMetric edpMetric33k">
								<strong>33K</strong>
								<span>{t("casesConteudoSocial.edpSeguidores")}</span>
							</div>

							<div className="edpMetric edpMetric60k">
								<strong>60K</strong>
								<span>{t("casesConteudoSocial.edpEngajamento")}</span>
							</div>
						</div>

						<div className="edpCardsRow">
							{edpCards.map((card, index) => (
								<div
									key={index}
									className={`edpCard edpCard${index + 1}`}
								>
									<img src={card} alt="" />
								</div>
							))}
						</div>

						<img
							src={celularEdp}
							alt=""
							className="edpPhone"
						/>

						<p className="edpLinkedinText">
							{ReactHtmlParser(t("casesConteudoSocial.edpLinkedinTexto"))}
						</p>
					</div>
				</section>

				<div className="caseTop">
					<a href="/#cases" className="caseNav caseNavHome">
						<img src={setaAzul} alt="" />
						<span>{t("botoes.voltar")}</span>
					</a>

					<a href="/CasesJogarJunto" className="caseNav caseNavNext">
						<span>{t("casesConteudoSocial.proximoCase")}</span>
						<img src={setaAzul} alt="" />
					</a> 
				</div>
			</CssEdp>

			<div className="clear" />
			<Footer />
		</>
	);
};

export default CasesConteudoSocial;